import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { GridFilter, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { InvBalance } from "../../models/inv-balance.model";
import { Warehouse } from "../../models/warehouse.model";

@Component({
  selector: "ngx-inv-balance-list",
  templateUrl: "./inv-balance-list.component.html",
  styleUrls: ["./inv-balance-list.component.scss"],
})
export class InvBalanceListComponent extends BaseFormComponent<InvBalance> {
  currentData: PagingDataResult<any> = new PagingDataResult<any>();
  hcolumns: form_control[];
  currentWarehouse: Warehouse;
  @ViewChild(KGridComponent) grid: KGridComponent;
  constructor(__id: FormContainerModel, protected selectorService: SelectorService, protected cd: ChangeDetectorRef, _tabsservice: TabularService) {
    super(selectorService, cd);
    this._id = __id;
    this.tabsservice = _tabsservice;
  }

  async setColumns() {
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.orignalColumns = (data as form_control[]).filter((f) => f.name === "WarehouseId");
            this.hcolumns = this.orignalColumns;
            this.columns = data as form_control[];
            this.columns = this.columns.sort((a, b) => a.order - b.order);
            this.setColumnAttribute();
            this.setFormGroup(this.model);
          }
        },
        (error) => this.getFailedHelper(error)
      );

    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (data) {
          this.orignalColumns = (data as form_control[]).filter((f) => f.name === "WarehouseId");
          this.hcolumns = this.orignalColumns;

          this.columns = data as form_control[];
          this.columns = this.columns.sort((a, b) => a.order - b.order);
          this.columns.forEach((x) => {
            if (x.name === "GoodsId") x.listVisible = false;
            if (x.name === "WarehouseTitle") x.listVisible = false;
            if (x.name === "GoodsCode") x.listVisible = true;
            if (x.name === "GoodsTitle") x.listVisible = true;
            if (x.name === "GoodsKindTitle") x.listVisible = true;
            if (x.name === "DefaultUnitTitle") x.listVisible = true;
            if (x.name === "MinAmount") x.listVisible = true;
            if (x.name === "ReOrderAmounte") x.listVisible = true;
            if (x.name === "MaxAmount") x.listVisible = true;
            if (x.name === "ROOfferAmount") x.listVisible = true;
            if (x.name === "LeadTime") x.listVisible = true;
            if (x.name === "RemainAmount") x.listVisible = true;
          });
          this.setColumnAttribute();
          this.setFormGroup(this.model);
        }
      });
  }
  async ngOnInit() {
    this.apiName = "InvBalance/GetInventoryBalancing";
    this.areaName = "Inventory";
    this.setColumns();
    this.loadData(undefined);
  }
  onChange($event: Warehouse) {
    if ($event) {
      this.currentWarehouse = $event;
      this.setValue("WarehouseId", $event.Id);
      this.model.WarehouseId = $event.Id;
      this.loadData(undefined);
    }
  }
  onDataStateChanged(event: GridFilter[]) {
    this.loadData(event);
  }
  getFilter(filter: GridFilter[]) {
    if (!filter) filter = [];
    let WarehouseId = this.formGroup?.controls["WarehouseId"]?.value ?? this.currentWarehouse?.Id;
    if (WarehouseId !== undefined && !filter.some((x) => x.Filed === "WarehouseId"))
      filter.push({
        Filed: "WarehouseId",
        Type: "F",
        Value: WarehouseId,
        Operator: "eq",
        Logic: "and",
        Skip: filter[0]?.Skip ?? 0,
        Take: filter[0]?.Take ?? 10,
      });
    if (!filter.some((x) => x.Filed === "FiscalYearId"))
      filter.push({
        Filed: "FiscalYearId",
        Type: "F",
        Value: this.accountService.authService.currentFiscalYear.Id,
        Operator: "eq",
        Logic: "and",
        Skip: filter[0]?.Skip ?? 0,
        Take: filter[0]?.Take ?? 10,
      });
    if (!filter.some((x) => x.Filed === "BranchId"))
      filter.push({
        Filed: "BranchId",
        Type: "F",
        Value: this.accountService.authService.currentBranchId,
        Operator: "eq",
        Logic: "and",
        Skip: filter[0]?.Skip ?? 0,
        Take: filter[0]?.Take ?? 10,
      });
    return filter;
  }
  loadData(event: GridFilter[]) {
    if (!this.accountService.authService.currentFiscalYear) setTimeout(() => this.loadData(event), 300);
    let filter: GridFilter[] = this.getFilter(event);
    if (filter !== undefined && filter.length > 0) {
      if (this.grid && this.grid.isRefreshing) return;
      if (this.grid) this.grid.isRefreshing = true;
      this.httpCommonService
        .GetFilterGrid(this.apiName, filter)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x: PagingDataResult<any>) => {
            this.currentData = x;
          },
          (error) => {
            1 === 1;
          }
        );
    }
  }
}
